import { FormControl, Select, SelectProps } from '@chakra-ui/react'
import { FieldError, useFormContext, useWatch } from 'react-hook-form'

import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { InputGroup, InputGroupProps } from '../components/InputGroup'
import { useCountries, useRegions } from '../hooks'
import { useEffect, useState } from 'react'
import { BaseAddressDto } from 'BrokerTsLib/src/dtos'
import { useNameof } from '../hooks/useNameof'


export const InsureeAddress = ({ addressPrefix, street = false, isDisabled, isDisabledStreet }: (InputGroupProps | SelectProps) & { addressPrefix: string, street?: boolean, isDisabledStreet?: boolean }) => {
  const banameof = useNameof<BaseAddressDto>(addressPrefix)
  const pcPath = banameof(x => x.postCode)
  const cityPath = banameof(x => x.city)
  const streetPath = banameof(x => x.street)
  const houseNumberPath = banameof(x => x.houseNumber)

  const {
    register,
    getFieldState,
    setValue
  } = useFormContext()

  let postCodeField = useWatch({ name: pcPath }) ?? ''
  const [validPsc, setValidPsc] = useState(false);

  const pcError = getFieldState(pcPath).error
  const cityError = getFieldState(cityPath).error
  const streetError = getFieldState(streetPath).error
  const houseNumberError = getFieldState(houseNumberPath).error

  useEffect(() => {
    setValidPsc(postCodeField.length == 5 && !pcError)
  }, [postCodeField, pcError]);

  const { data: countriesData } = useCountries()
  const { data: citiesData } = useRegions(postCodeField, { enabled: validPsc })
  const cities = validPsc ? citiesData?.data.filter(x => (x.city?.length ?? 0) > 0) ?? [] : []

  return (
    <>
      {
        street &&
        <FormGroup>
          <FormControl isInvalid={!!streetError} isRequired>
            <FormLabel>Ulice</FormLabel>

            <InputGroup placeholder="Např. Dlouhá" htmlSize={24}
              {...register(streetPath)}
              isDisabled={isDisabled && isDisabledStreet}
              errors={streetError}
            />
          </FormControl>

          <FormControl isInvalid={!!houseNumberError} isRequired>
            <FormLabel>Číslo popisné nebo orientační</FormLabel>

            <InputGroup placeholder="Např. 123" htmlSize={4} {...register(houseNumberPath)} isDisabled={isDisabled && isDisabledStreet} errors={houseNumberError} />
          </FormControl>
        </FormGroup>
      }

      <FormGroup>
        <FormControl isInvalid={!!pcError} isRequired>
          <FormLabel htmlFor={pcPath} tooltip="Zadejte poštovní směrovací číslo obce. Údaj lze nalézt na webových stránkách www.psc.cz.">
            PSČ
          </FormLabel>
          <InputGroup
            id={pcPath}
            type='number'
            placeholder="00000"
            autoComplete="postal-code"
            errors={pcError as FieldError}
            htmlSize={4}
            isDisabled={isDisabled}
            {...register(pcPath, {
              onChange: () => setValue(cityPath, undefined)
            })}
          />
        </FormControl>

        <FormControl isRequired isInvalid={!!cityError}>
          <FormLabel>Město</FormLabel>

          {(cities?.length ?? 0) > 0 &&
            <Select isDisabled={!validPsc || cities.length === 0 || isDisabled} {...register(banameof(x => x.city))}>
              <option disabled value=''>
                Vyberte obec
              </option>
              {
                cities.map(item =>
                  <option value={item.city} key={item.city}>{item.city}</option>
                )
              }
            </Select>}
          {(cities?.length ?? 0) == 0 && <Select isDisabled={true} defaultValue=''><option disabled value=''>Vyberte obec</option></Select>}
        </FormControl>

        <FormControl>
          <FormLabel>Stát</FormLabel>

          <Select defaultValue="CZ" isDisabled={true} {...register(banameof(x => x.country))}>
            {
              countriesData?.data.map(item =>
                <option value={item.id} key={item.id}>{item.name}</option>
              )
            }
          </Select>
        </FormControl>
      </FormGroup>
    </>
  )
}